import React, { ReactElement, ReactNode } from 'react';

import { IconButton, Stack, Typography } from '@mui/material';
import { RemoveItemIcon } from './icons';

interface ListWithRemoveProps<T> {
  items?: T[];
  onRemove?: (item: T) => void;
  selectedItem?: T;
  hideRemoveButtonFn?: (item: T) => boolean;
  disableFn?: (item: T) => boolean;
  onClick?: (item: T) => void;
  emptyListText?: string;
  keyFn: (item: T) => string;
  labelFn: (item: T) => ReactNode | string;
  spacing?: number;
}

export function ListWithRemove<T>(props: ListWithRemoveProps<T>) {
  const {
    items = [],
    onRemove,
    selectedItem,
    hideRemoveButtonFn,
    disableFn,
    onClick,
    emptyListText = 'Žiadne položky',
    keyFn,
    labelFn,
    spacing = 1,
  } = props;

  return (
    <Stack direction="column" spacing={spacing} useFlexGap>
      {items.length === 0 && (
        <Typography variant="body1" sx={{ flexGrow: 1 }}>
          {emptyListText}
        </Typography>
      )}
      {items.map((item) => {
        const label = labelFn(item);
        const hideRemoveButton = hideRemoveButtonFn && hideRemoveButtonFn(item);
        const isDisabled = disableFn && disableFn(item);
        return (
          <Stack
            direction="row"
            spacing={0}
            useFlexGap
            flexWrap="wrap"
            alignItems="center"
            key={keyFn(item)}
            onClick={() => onClick && onClick(item)}
          >
            <IconButton
              size="small"
              onClick={() => onRemove && onRemove(item)}
              disabled={isDisabled || hideRemoveButton}
              sx={{ width: '40px' }}
            >
              {!hideRemoveButton && <RemoveItemIcon color="primary" />}
            </IconButton>

            {typeof label === 'string' ? (
              <Typography
                variant="body1"
                sx={{
                  flexGrow: 1,
                  color: selectedItem === item ? 'primary.main' : 'text.primary',
                  textDecoration: selectedItem === item ? 'underline' : 'none',
                }}
              >
                {label}
              </Typography>
            ) : (
              label
            )}
          </Stack>
        );
      })}
    </Stack>
  );
}
